import { objectToFiltersQuery } from '../utils/objectToFiltersQuery';
import { BaseOrganizationEndpoints } from './base';
import {
  AddTagToResourcePayload,
  Tag,
  TagCategoryGetResponse,
  TagFilters,
  TagGetResponse,
  UpdateTagResourcePayload
} from '../types/tags';

export class Tags extends BaseOrganizationEndpoints {
  async getTags(filters?: TagFilters) {
    return this.requestWithStatus<TagGetResponse>(
      'GET',
      `/v1/tags${objectToFiltersQuery(filters)}`
    );
  }

  async getTag(pageFilters: TagFilters) {
    if (!pageFilters.id) throw new Error('Tag ID is required');
    return await this.requestWithStatus<Tag>(
      'GET',
      `/v1/tags/${pageFilters.id}`
    );
  }

  async createTag(tag: Partial<Tag>) {
    return this.requestWithStatus<Tag>('POST', '/v1/tags', tag);
  }

  async updateTag(idTag: string, tag: Partial<Tag>) {
    return this.requestWithStatus<Tag>('PUT', `/v1/tags/${idTag}`, tag);
  }

  async deleteTag(idTag: string) {
    return this.requestWithStatus<{ success: boolean }>(
      'DELETE',
      `/v1/tags/${idTag}`
    );
  }

  async getCategories() {
    return this.requestWithStatus<TagCategoryGetResponse>(
      'GET',
      '/v1/tags/categories'
    );
  }

  async getResourceTags(idResource: string) {
    return this.requestWithStatus<TagGetResponse>(
      'GET',
      `/v1/resources/${idResource}/tags`
    );
  }

  async addTagToResource(
    idResource: string,
    resourceTag: AddTagToResourcePayload | AddTagToResourcePayload[]
  ) {
    if (Array.isArray(resourceTag)) {
      return this.requestWithStatus<TagGetResponse>(
        'POST',
        `/v1/resources/${idResource}/tags/batch`,
        { tags: resourceTag }
      );
    }

    return this.requestWithStatus<TagGetResponse>(
      'POST',
      `/v1/resources/${idResource}/tags`,
      resourceTag
    );
  }

  async updateResourceTag(
    idResource: string,
    idTag: string,
    resourceTag: UpdateTagResourcePayload
  ) {
    return this.requestWithStatus<TagGetResponse>(
      'PUT',
      `/v1/resources/${idResource}/tags/${idTag}`,
      resourceTag
    );
  }

  async deleteResourceTag(idResource: string, idTag: string) {
    return this.requestWithStatus<TagGetResponse>(
      'DELETE',
      `/v1/resources/${idResource}/tags/${idTag}`
    );
  }

  async removeAllTagsFromResource(idResource: string) {
    const resourceTags = await this.getResourceTags(idResource);
    const tags = resourceTags?.result?.tags;

    const tagIds = tags?.map((tag) => tag.id) || [];

    if (!tagIds.length) return;

    return this.requestWithStatus<TagGetResponse>(
      'DELETE',
      `/v1/resources/${idResource}/tags/batch`,
      {
        resource_id: idResource,
        tag_ids: tagIds
      }
    );
  }
}
